(function () {
    'use strict';
    angular.module('app').directive('selectioncommandcopytocurrent', selectioncommand_copytocurrent);
    selectioncommand_copytocurrent.$inject = ['$window'];
    function selectioncommand_copytocurrent($window) {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                copyToCurrentDialogShown: '=?'
            },
            controller: 'copytocurrent',
            templateUrl: 'app/selectioncommand/selectioncommand_copytocurrent.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();